import styled from 'styled-components/macro';

import TextBase from '@components/common/core/DataDisplay/Text';

export const TotalLabel = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
  line-height: 120%;
  white-space: nowrap;
`;

export const ForeCastAmount = styled(TextBase)`
  color: ${({ theme }) => theme.colors.gray[2]};
  line-height: 120%;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
`;

export const TotalAmountText = styled(TextBase)`
  line-height: 120%;
  white-space: nowrap;
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 4px;
  overflow: hidden;
`;
